import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../auth/authConfig';
import { logger } from '../../utils/logger';

export function LoginButton() {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      logger.error('Login failed:', error);
    }
  };

  return (
    <button
      onClick={handleLogin}
      style={{
        backgroundColor: 'var(--color-blue-500)',
        color: 'white',
        fontWeight: 'bold',
        padding: '12px 24px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '16px',
        transition: 'background-color 0.2s',
      }}
      onMouseOver={(e) =>
        (e.currentTarget.style.backgroundColor = 'var(--color-blue-600)')
      }
      onMouseOut={(e) =>
        (e.currentTarget.style.backgroundColor = 'var(--color-blue-500)')
      }
    >
      🔑 Sign in with Microsoft
    </button>
  );
}

export function LogoutButton() {
  const { instance } = useMsal();

  const handleLogout = async () => {
    try {
      await instance.logoutRedirect({
        postLogoutRedirectUri: import.meta.env.VITE_MSAL_LOGIN_REDIRECTURI,
      });
    } catch (error) {
      logger.error('Logout failed:', error);
    }
  };

  return (
    <button
      onClick={handleLogout}
      style={{
        backgroundColor: 'var(--color-red-500)',
        color: 'white',
        fontWeight: 'bold',
        padding: '8px 16px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        transition: 'background-color 0.2s',
      }}
      onMouseOver={(e) =>
        (e.currentTarget.style.backgroundColor = 'var(--color-red-600)')
      }
      onMouseOut={(e) =>
        (e.currentTarget.style.backgroundColor = 'var(--color-red-500)')
      }
    >
      Sign out
    </button>
  );
}
